import { fetchRequest } from '../../auth/fetch-request';
import { LibraryNode } from './document-library-model';

type WorksheetResult<T = any> = {
  service?: string;
  action?: string;
  workflow?: string;
  success?: boolean;
  result?: T;
  errors?: string[];
  alerts?: any[];
};

export type LibraryScope = {
  locationCode?: string;
  departmentCode?: string;
  worksheetType?: string;
  workflow?: string;
};

export const getDocumentLibraryRequest = fetchRequest<LibraryScope, WorksheetResult<LibraryNode[]>>({
  method: 'post',
  microservice: true,
  body: ({ locationCode, departmentCode, worksheetType, workflow }: LibraryScope) => ({
    service: 'document-content',
    action: 'getlibrarylist',
    workflow: workflow || 'ED_Coding_USACS',
    data: {
      locationCode: locationCode || 'USACS_MAME',
      departmentCode: departmentCode || 'ED',
      worksheetType: worksheetType || 'PHYSICIAN',
    },
  }),
});

const getDocumentContentRequest = fetchRequest<LibraryNode, WorksheetResult<string>>({
  method: 'post',
  microservice: true,
  body: ({ bucket, path }: LibraryNode) => ({
    service: 'document-content',
    action: 'getcontent',
    data: {
      bucket,
      filekey: path,
      markAsRead: false,
    },
  }),
});

function base64ToBlob(base64: string, type = 'application/octet-stream') {
  const binStr = atob(base64);
  const len = binStr.length;
  const arr = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    arr[i] = binStr.charCodeAt(i);
  }
  return new Blob([arr], { type: type });
}

export async function openAwsDocument(node: LibraryNode): Promise<Window | undefined> {
  const isPdf = node.path.indexOf('pdf') > -1;
  const isExternal = node.path.indexOf('http') > -1;
  if (isExternal) {
    return window.open(node.path, '_blank');
  }

  try {
    const r = await getDocumentContentRequest(node);

    let data = r?.result?.length > 0 ? r.result : undefined;
    if (data) {
      if (isPdf) {
        const blob = base64ToBlob(data, 'application/pdf');
        const url = URL.createObjectURL(blob);
        const pdfWindow = window.open('');
        pdfWindow.document.write(` <style>body{margin:0}</style><iframe width="100%" height="100%" src=" ${url} "></iframe>`);

        return pdfWindow;
      } else {
        // TODO: other formats
        return undefined;
      }
    }
  } catch (_) {
    console.info('error getting document url', _);
  }
  return undefined;
}

